export default "__VITE_ASSET__CPLjmZd$__";